var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4805 2.125H17.5993C17.6481 2.57544 17.5993 4.21369 17.5993 5.78021C18.5381 3.61144 20.6975 2.20675 23.6849 2.125V4.88434C19.9802 4.98277 17.5993 6.7011 17.5993 10.76V17.0444H14.4805C14.4805 17.0444 14.4955 2.97916 14.4805 2.125Z",
    fill: "#BC172F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.513 2.125H10.3942C10.3453 2.57544 10.3942 4.21369 10.3942 5.78021C9.45532 3.61144 7.29411 2.20675 4.30859 2.125V4.88434C8.01326 4.98277 10.3942 6.7011 10.3942 10.76V17.0444H13.513C13.513 17.0444 13.4999 2.97916 13.513 2.125Z",
    fill: "#BC172F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9998 0.132812V3.11737C27.0159 3.10569 9.52148 3.11737 9.52148 3.11737V0.132812H27.9998Z",
    fill: "#BC172F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4783 0.132812V3.11737C17.4944 3.10569 0 3.11737 0 3.11737V0.132812H18.4783Z",
    fill: "#BC172F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6a3669547e7a74784a54e117b7b3fd71.svg";
export { ForwardRef as ReactComponent };